module.exports = __webpack_public_path__ + "img/notification.b1d5d523.svg";